/* eslint max-classes-per-file: 0 */

import {
  PublicationStorageFileHistory as Data,
  PublicationStorageFileHistoryCollection as Collection,
} from '@/typings/api/Publication'

import { Fabric } from '@/store/createCrudModule'
import { PublicationsStorageFilesHistoryAdapter as Adapter } from './PublicationsStorageFilesHistoryAdapter'


export const fabric = Fabric<Data, Collection>()

type S = PublicationStorageFileHistoryState
type G = PublicationStorageFileHistoryGetters
type M = PublicationStorageFileHistoryMutations
type A = PublicationStorageFileHistoryActions


export class PublicationStorageFileHistoryState extends fabric.State {
}

export class PublicationStorageFileHistoryGetters extends fabric.Getters<S> {
}

export class PublicationStorageFileHistoryMutations extends fabric.Mutations<S> {
}

export class PublicationStorageFileHistoryActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new Adapter();

  protected readonly idName = 'id';

  public downloadArchive(options: Record<string, unknown>) {
    return this.adapter.api.historyReport(options)
  }
}
